import Stack from '@mui/material/Stack/Stack'
import Typography from '@mui/material/Typography/Typography'

import { WaitlistPetClientDto } from 'service-api/src/types/api'

interface Props {
  pet: WaitlistPetClientDto
}

export const Pets = ({ pet }: Props) => {
  return (
    <Stack direction="row" alignItems="baseline" gap={0.5}>
      <Typography component="span" variant="subtitle2">
        {pet.displayName || pet.locationPetProfile?.displayName || ''}
      </Typography>
    </Stack>
  )
}
